import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";


const AboutUs = ({ token }) => {
  const { t } = useTranslation();
  return (
    <Container>
      <div style={{ marginTop: token ? "0px" : "10%", marginBottom: "3rem" }}>
      <h2
        style={{
          color: "#59B089",
          fontSize: "2.8rem",
          fontWeight: "700",
          lineHeight: "98.5px",
          textAlign: "left",
          textTransform: "none",
        }}
      >
        {t("platformTexts.aboutTitle")}
      </h2>
      <div dangerouslySetInnerHTML={{__html:t("platformTexts.aboutText")}}></div>
</div>
    </Container>
  );
};

export default AboutUs;
